import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {  Link, useParams } from 'react-router-dom';
import { ModifyNumberRequest,  PhoneNumberListClient } from '../../api/server';
import { Button, FormLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { ExtendedClient } from '../../api/ExtendedClient';

function PhoneNumberList({listType}) {
    const globalInfo = useSelector((state) => state.globalInfo)
    let { currentPhoneNumberId } = useParams();
    const [phoneNumberDigits, setPhoneNumberDigits] = useState("");
    const [phoneNumberList, setPhoneNumberList] = useState([])

    const [addMode, setAddMode] = useState(false)

    function refreshPhoneBook() {
        const client = (new ExtendedClient(PhoneNumberListClient)).getClient();
        
        if (currentPhoneNumberId) {

            
             client.list(currentPhoneNumberId, listType).then((data) => {
                setPhoneNumberList(data);
             })
        }
    }

    function deleteByNumber(numberToBeDeleted) {
        const client = (new ExtendedClient(PhoneNumberListClient)).getClient();

        let request = new ModifyNumberRequest();
        request.number = numberToBeDeleted;
        request.type = listType;

        client.removeNumber(currentPhoneNumberId, request).then(() => {
            refreshPhoneBook();
        })

    }
    function cancel(){
        setAddMode(false) ;
            setPhoneNumberDigits("")
    }
    
    function addToPhoneBook() {
        const client = (new ExtendedClient(PhoneNumberListClient)).getClient();

        let request = new ModifyNumberRequest();
        request.number = phoneNumberDigits;
        request.type = listType;
        
        client.addNumber(currentPhoneNumberId, request).then(() => {
            refreshPhoneBook();
            setAddMode(false) ;
            setPhoneNumberDigits("")
        })

    }

    useEffect(() => {
        refreshPhoneBook();

        // eslint-disable-next-line
    }, [currentPhoneNumberId, globalInfo, listType])

    const isValidPhoneNumber = phoneNumberDigits.length === 10 && /^[0-9]{10}$/.test(phoneNumberDigits);

    return (

        <div>
              {<Button variant='contained' component={Link} to={`/prioritylist/${currentPhoneNumberId}`}>Priority Phone Numbers</Button> }&nbsp; &nbsp;
                { <Button variant='contained' component={Link} to={`/ignorelist/${currentPhoneNumberId}`}>Ignore Phone Numbers</Button> }&nbsp; &nbsp;
                { <Button variant='contained' component={Link} to={`/hanguplist/${currentPhoneNumberId}`}>Banned Phone Numbers</Button> }&nbsp; &nbsp;
                
            <h1>{listType} List</h1>
            {listType === "Priority" && <h3>When these numbers call, the call will be directly transferred to the Store Location.</h3>}
            {listType === "Ignore" && <h3>When these numbers call, the call will be transferred to the Voicemail.</h3>}
            {listType === "Hangup" && <h3>When these numbers call, the call will disconnect.</h3>}
            
            
            {
                !(!addMode && (phoneNumberList && phoneNumberList.length) > 0) && <>
                    
                    <FormLabel>10 Digit Phone Number: </FormLabel>
                    <TextField fullWidth={true} value={phoneNumberDigits} onChange={(e) => { setPhoneNumberDigits(e.target.value) }}></TextField>
                    <br></br><br></br>
                    <Button variant='outlined' onClick={() => { addToPhoneBook(); }} disabled={!isValidPhoneNumber} >Save</Button> &nbsp;
                    <Button variant='outlined' onClick={() => { cancel() }}>Cancel</Button>
                </>

            }
            <br></br><br></br>
            {
                (!addMode && (phoneNumberList && phoneNumberList.length > 0)) &&
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <strong>Telephone Number</strong>
                                    </TableCell>

                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    phoneNumberList.map((item, index) => {
                                        return <TableRow key={item}>
                                            <TableCell>
                                                {item} 
                                            </TableCell>
                                            <TableCell>
                                                <Button variant='outlined' onClick={() => { deleteByNumber(item) }} >Delete</Button>
                                            </TableCell>
                                        </TableRow>
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>

                </>
            }
            <br />
            {(!addMode && (phoneNumberList && phoneNumberList.length > 0)) && 
                <Button variant='outlined' onClick={() => { setAddMode(!addMode) }}>Add New
                </Button>
            }
        </div>
    )
}

export default PhoneNumberList